import { ClientContext, ClientOptions, GraphQLClient } from 'graphql-hooks';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { clientConfig } from './utilities/configService';
import { appInsights } from './services/appInsights';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const getSettingsObject = () => {
    var clientInstance: string = clientConfig?.CLIENT_INSTANCE || '';
    var platformName: string = clientConfig?.PLATFORM_NAME || '';

    if (clientInstance === '') {
        console.error('clientInstance is empty string');
        clientInstance = 'pgff';
    }

    if (platformName === '') {
        console.error('platformName is empty string');
        clientInstance = 'icfdemo';
    }

    var settingsObject: ClientOptions = {
        url: import.meta.env.REACT_APP_API_PROXY_URL + '/Content',
        headers: { "X-Application-Name": platformName, "X-Application-Instance": clientInstance }
    };

    return settingsObject;
}

const client = new GraphQLClient(getSettingsObject());

if (import.meta.env.PROD) {
    console.log = () => { }
    console.error = () => { } //Comment out to show error in console
    console.debug = () => { }
}

window.addEventListener('unhandledrejection', (event) => {
    appInsights.trackException({
        exception: event.reason instanceof Error ? event.reason : new Error(String(event.reason)),
        severityLevel: 3,
        properties: { type: 'unhandledrejection' }
    });
});

root.render(
    <BrowserRouter>
        <ClientContext.Provider value={client}>
            <App />
        </ClientContext.Provider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
